<template>
  <div>
    Future Improvement
  </div>
</template>

<script>
export default {
  name: "MyMessagesIndex",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      import_to_file:
        "import MyMessagesIndex from '@~/Documents/NutriBit/frontend/src/pages/MyMessages/MyMessagesIndex';"
    };
  },
  created() {}
};
</script>

<style></style>
